import { IconButton, styled } from "@mui/material";
import UploadAddMoreFilesButton from "./UploadAddMoreFilesButton";
import { ReactComponent as Icon } from "../icons/left_arrow.svg";

interface IProps {
  text: string;
  back: () => void;
  files?: any;
  setFiles?: (files: any) => void;
}

const UploadMoveBack = (props: IProps) => {
  const {
    text,
    back,
    files,
    setFiles
  } = props;

  return (
    <Container>
      <FlexContainer>
        <IconButton
          onClick={back}
          sx={{
            background: "var(--color-add-dark)",
            width: "36px",
            height: "36px",
            minWidth: "unset",
            color: "white",
            padding: 0,
            "&:hover": {
              background: "#31314D"
            },
          }}
        >
          <Icon width="24px" height="auto" style={{ opacity: "0.4" }}/>
        </IconButton>
        <p>{text}</p>
      </FlexContainer>
      {text.includes("Multiple") && (
        <UploadAddMoreFilesButton
          files={files}
          setFiles={setFiles ? setFiles : () => ""}
        />
      )}
    </Container>
  );
};

export default UploadMoveBack;

const Container = styled("div")({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  "& p": {
    fontSize: "20px",
    textTransform: "capitalize !important"
  }
});

const FlexContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
